import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import 'semantic-ui-css/semantic.min.css';
import AddUsersContent from "../AddUsersContent";

class AddUsersModal extends React.Component {

  toggle = () => {};

  render() {

    return(
      <div>
        <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>Add Users</MDBModalHeader>
          <MDBModalBody>

            <div>
              <AddUsersContent userGroupDetails={this.props.userGroupDetails} closeModal={this.props.closeModal}/>
            </div>

          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }
}

export default AddUsersModal;
